import InputLogin from "../InputLogin"
import styles from "./CardLogin.module.css";
import { useState } from "react"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


function CardLogin() {
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const navigate = useNavigate();

    const requestLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email,
                    "password": senha
                }),
                credentials: "include"
            })

            if (!response.ok) throw new Error("Login inválido");

            await response.json();

            toast.success("Login realizado com sucesso!");
            navigate("/")

        } catch (err) {
            console.error(err.message);
            toast.error("Login inválido! Verifique email e senha.");
        }
    }

    return (
        <form className={styles.card} onSubmit={requestLogin}>
            <div className={styles.containerInfo}>
                <h2 className={styles.title}> Entrar na sua conta</h2>
                <p className={styles.text}>Digite suas credencias para acessar o sistema</p>
            </div>
            <div className={styles.containerInput}>
                <InputLogin
                    folder="Email"
                    type="email"
                    placeholder="seu@email.com"
                    icon={false}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <InputLogin
                    folder="Senha"
                    type="password"
                    placeholder="••••••••••••"
                    icon={true}
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                />
                <button className={styles.btn} type="submit">Entrar</button>
                
            </div>
        </form>
    )
}

export default CardLogin;